module.exports = __webpack_public_path__ + "static/rollover_remodelar-0c0a04f3d773872d422c5440659d1099.svg";